<template>
  <div class="container content-container" :style="mainStyle">
    <el-row :gutter="15" style="margin-left: 0!important;margin-right: 0!important;">
      <el-col :span="6" :md="6" :sm="24" :xs="24" v-if="$slots['left']">
        <box-container box-class="search-container">
            <span slot="header">
              <span style="float:left">筛选</span> 
              <el-button size="small" plain icon="icon icon-refresh" @click="reset" style="float:left" title="重置"></el-button>
              <el-button size="small" plain icon="icon icon-export" @click="handleExportData" v-if="showExportData" title="导出"></el-button>
              <div style="clear:both"></div>
            </span>
            <div :class="['form-container', overflow ? 'form-flow' : '']" :style="formStyle">
              <div ref="left">
                <slot name="left"></slot>
              </div>
            </div>
            <div class="search-btns">
              <el-button size="small" type="primary" plain @click="search" class="search-button">查询</el-button>
            </div>
        </box-container>
      </el-col>
      <el-col :span="$slots['left'] ? 18 : 24" :md="$slots['left'] ? 18 : 24" :sm="24" :xs="24">
        <div class="box operate-container" v-if="$slots['operate']">
          <slot name="operate"></slot>
        </div>
        <transition name="main-top-fade" mode="out-in">
          <box-container box-class="main-top-container" ref="mainTop" v-if="$slots['main-top']" v-show="showMainTop">
            <div slot="header">
              {{mainTopTitle}}
              <el-button 
                size="small" 
                plain 
                icon="icon icon-xxx" 
                class="close-button" 
                v-if="showMainTopClose"
                @click="closeMainTop()"></el-button>
            </div>
            <slot name="main-top"></slot>
          </box-container>
          <box-container box-class="main-top-container" ref="mainDetail" v-if="$slots['main-detail']">
            <slot name="main-detail"></slot>
          </box-container>
        </transition>
        <slot name="main"></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import searchReset from '@/components/search-reset.vue'
export default {
  components: {
    searchReset
  },
  data () {
    return {
      showMainTop: !this.mainTopClose,
      mainStyle: { maxHeight: 600, height: 600 },
      formStyle: { maxHeight: 600 },
      overflow: false
    }
  },
  props: {
    mainTopTitle: {
      type: String,
      default: ''
    },
    showMainTopClose: {
      type: Boolean,
      default: false
    },
    mainTopClose: {
      type: Boolean,
      default: true
    },
    beforeMainTopClose: Function,
    search: Function,
    reset: Function,
    exportData: Function,
    showExport: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    openMainTop () {
      this.showMainTop = true
    },
    closeMainTop () {
      if (typeof this.beforeMainTopClose === 'function') {
        this.hide(this.beforeMainTopClose())
      } else {
        this.hide()
      }
    },
    hide (cancel) {
      if (cancel !== false) {
        this.showMainTop = false
      }
    },
    resizeMainContainer () {
      this.$store.dispatch('ResizeWindow', {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight - (this.framePage ? 40 : 0)
      })
      this.resize()
    },
    resize () {
      this.mainStyle.height = this.mainStyle.maxHeight = `${this.windowSize.height - (this.framePage ? 64 : 14)}px`
      this.overflow = this.$refs.left ? (this.$refs.left.offsetHeight > this.windowSize.height - (this.framePage ? 170 : 140)) : false
      this.formStyle.height = this.overflow ? `${this.windowSize.height - 140}px` : 'auto'
    },
    handleExportData () {
      if (this.showExportData) {
        this.exportData()
      }
    }
  },
  computed: {
    ...mapGetters([
      'windowSize'
    ]),
    showExportData () {
      return this.showExport && typeof this.exportData === 'function'
    }
  },
  watch: {
    'windowSize.height' (newval, oldval) {
      this.resize()
    }
  },
  mounted () {
    var vm = this
    window.onresize = () => {
      vm.resizeMainContainer()
    }
    vm.resizeMainContainer()
  }
}
</script>

<style>
.content-container {
  padding-top: 14px;
}

.search-container {
  padding: 10px;
}
.search-container.box .form-container .el-row {
  margin-bottom: 20px;
}
.search-container .el-form-item {
  margin-bottom: 0px;
}
.search-container.box .el-form-item__label {
  line-height: 20px;
}
.search-container.box .el-select{
  width: 100%;
}
.search-container .box-body {
  padding: 0;
}
.search-container .el-checkbox {
  margin-left: 0px;
  margin-right: 10px;
}
.search-container .form-container {
  overflow-y: none;
  padding: 10px 10px 0px 10px;
}
.search-container .form-container.form-flow{
  overflow-y: scroll;
}
.search-container .search-btns {
  padding: 10px 10px;
  border-top: 1px solid #f4f4f4;
}
.search-container .box-header .el-button {
  padding: 3px 0px 0px 6px;
}

.main-top-container .el-form-item {
  margin-bottom: 0px;
}

.main-top-fade-enter-active,
.main-top-fade-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transform-origin: center top;
}
.main-top-fade-enter,
.main-top-fade-leave-active {
  opacity: 0;
  transform: scaleY(0);
}

.main-top-container .detail-button{
  margin-top: 10px;
}
@media screen and (min-width: 768px){  
  .main-top-container .detail-button{
    text-align: left;
    padding-left: 80px;
  }
}

.operate-container {
  padding: 10px 0px 10px 10px;
  border-bottom: 1px solid #ebeef5;
}
.operate-container .el-button-group .el-button {
  border: 0;
}
@media screen and (max-width: 768px){  
  .operate-container .el-button--small {
    padding: 8px 10px;
  }

  .main-top-container .detail-button{
    text-align: right;
  }
}

</style>

<style lang="scss">
  @import "../style/main";
</style>


// WEBPACK FOOTER //
// src/layout/content-layout.vue